export default __webpack_public_path__ + "static/media/Promise2.7b7d1555.jpg";